class menu {
  _construct() {
    this.$menu = document.querySelector('.main-header')
    this.$button = document.querySelector('.trigger-menu')
  }

  _toggleMenu() {
    this.$menu.classList.toggle('active', !this.$menu.classList.contains('active'))
  }

  init() {
    this._construct()
    this.$button.addEventListener('click', (event) => {
      event.preventDefault()
      // --
      this._toggleMenu()
    })

    window.addEventListener('scroll', () => {
      this.$menu.classList.toggle('sticky', window.scrollY >= 100)
    })
  }
}
export default menu
